var _path, _path2, _path3, _path4, _path5, _path6, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _circle1, _circle10, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 308,
    height: 102,
    viewBox: "0 0 308 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M295.823 41.48C294.563 41.48 293.681 41.228 293.177 40.724C292.673 40.184 292.421 39.518 292.421 38.726V37.862C292.421 37.07 292.673 36.422 293.177 35.918C293.681 35.378 294.563 35.108 295.823 35.108C297.083 35.108 297.965 35.378 298.469 35.918C298.973 36.422 299.225 37.07 299.225 37.862V38.726C299.225 39.518 298.973 40.184 298.469 40.724C297.965 41.228 297.083 41.48 295.823 41.48ZM283.619 71.828H293.663V51.308H283.619V47.636H297.983V71.828H307.379V75.5H283.619V71.828Z",
    fill: "#1F2937"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M263.066 75.5C260.942 75.5 259.376 74.906 258.368 73.718C257.396 72.53 256.91 71 256.91 69.128V51.308H247.622V47.636H254.534C255.47 47.636 256.118 47.456 256.478 47.096C256.874 46.7 257.072 46.034 257.072 45.098V37.808H261.23V47.636H273.92V51.308H261.23V71.828H273.92V75.5H263.066Z",
    fill: "#1F2937"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M231.065 41.48C229.805 41.48 228.923 41.228 228.419 40.724C227.915 40.184 227.663 39.518 227.663 38.726V37.862C227.663 37.07 227.915 36.422 228.419 35.918C228.923 35.378 229.805 35.108 231.065 35.108C232.325 35.108 233.207 35.378 233.711 35.918C234.215 36.422 234.467 37.07 234.467 37.862V38.726C234.467 39.518 234.215 40.184 233.711 40.724C233.207 41.228 232.325 41.48 231.065 41.48ZM218.861 71.828H228.905V51.308H218.861V47.636H233.225V71.828H242.621V75.5H218.861V71.828Z",
    fill: "#1F2937"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M184.916 71.828H193.07V51.308H184.916V47.636H197.39V54.656H197.66C198.236 52.46 199.316 50.75 200.9 49.526C202.52 48.266 204.572 47.636 207.056 47.636H210.944V51.956H205.706C203.222 51.956 201.206 52.676 199.658 54.116C198.146 55.556 197.39 57.446 197.39 59.786V71.828H208.19V75.5H184.916V71.828Z",
    fill: "#1F2937"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M151.295 75.5V47.636H155.291V50.876H155.507C155.939 49.796 156.551 48.878 157.343 48.122C158.135 47.366 159.305 46.988 160.853 46.988C162.473 46.988 163.679 47.402 164.471 48.23C165.263 49.022 165.749 50.066 165.929 51.362H166.091C166.595 50.102 167.315 49.058 168.251 48.23C169.187 47.402 170.483 46.988 172.139 46.988C174.407 46.988 175.919 47.78 176.675 49.364C177.467 50.948 177.863 53.216 177.863 56.168V75.5H173.867V56.87C173.867 54.494 173.615 52.856 173.111 51.956C172.643 51.02 171.761 50.552 170.465 50.552C169.313 50.552 168.377 50.93 167.657 51.686C166.937 52.406 166.577 53.522 166.577 55.034V75.5H162.581V56.87C162.581 54.494 162.329 52.856 161.825 51.956C161.357 51.02 160.493 50.552 159.233 50.552C158.081 50.552 157.127 50.93 156.371 51.686C155.651 52.406 155.291 53.522 155.291 55.034V75.5H151.295Z",
    fill: "#1F2937"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M132.686 76.148C130.67 76.148 128.852 75.806 127.232 75.122C125.648 74.438 124.28 73.466 123.128 72.206C122.012 70.91 121.148 69.38 120.536 67.616C119.924 65.816 119.618 63.818 119.618 61.622C119.618 59.39 119.924 57.374 120.536 55.574C121.184 53.774 122.066 52.244 123.182 50.984C124.298 49.688 125.63 48.698 127.178 48.014C128.762 47.33 130.508 46.988 132.416 46.988C134.288 46.988 135.98 47.33 137.492 48.014C139.04 48.698 140.354 49.652 141.434 50.876C142.514 52.064 143.342 53.486 143.918 55.142C144.494 56.798 144.782 58.616 144.782 60.596V62.648H124.154V63.944C124.154 65.168 124.352 66.302 124.748 67.346C125.144 68.39 125.702 69.29 126.422 70.046C127.178 70.802 128.078 71.396 129.122 71.828C130.202 72.224 131.39 72.422 132.686 72.422C134.558 72.422 136.178 71.99 137.546 71.126C138.914 70.262 139.958 69.074 140.678 67.562L143.864 69.722C143.036 71.594 141.65 73.142 139.706 74.366C137.798 75.554 135.458 76.148 132.686 76.148ZM132.416 50.552C131.228 50.552 130.13 50.768 129.122 51.2C128.114 51.632 127.232 52.226 126.476 52.982C125.756 53.738 125.18 54.638 124.748 55.682C124.352 56.69 124.154 57.806 124.154 59.03V59.408H140.138V58.814C140.138 57.59 139.94 56.474 139.544 55.466C139.184 54.458 138.662 53.594 137.978 52.874C137.33 52.118 136.52 51.542 135.548 51.146C134.612 50.75 133.568 50.552 132.416 50.552Z",
    fill: "#1F2937"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 65,
    cy: 9,
    r: 9,
    fill: "#4B5563"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 12.5,
    r: 5,
    fill: "#4B5563"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 33.5,
    r: 5,
    fill: "#4B5563"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 70.5,
    r: 5,
    fill: "#4B5563"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 89.5,
    r: 5,
    fill: "#4B5563"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 111,
    cy: 89.5,
    r: 5,
    fill: "#4B5563"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 116,
    cy: 33.5,
    r: 5,
    fill: "#4B5563"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 94,
    cy: 12.5,
    r: 5,
    fill: "#4B5563"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 65,
    cy: 36.5,
    r: 5,
    fill: "#4B5563"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 96.5,
    r: 5,
    fill: "#4B5563"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 85.5,
    r: 9,
    fill: "#4B5563"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 87,
    cy: 85.5,
    r: 9,
    fill: "#4B5563"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M65 53.5C71.6274 53.5 77 58.8726 77 65.5C77 72.1274 71.6274 77.5 65 77.5C58.3726 77.5 53 72.1274 53 65.5C53 58.8726 58.3726 53.5 65 53.5ZM27.5 54.5C33.299 54.5 38 59.201 38 65C38 70.799 33.299 75.5 27.5 75.5C21.701 75.5 17 70.799 17 65C17 59.201 21.701 54.5 27.5 54.5ZM102.5 54.5C108.299 54.5 113 59.201 113 65C113 70.799 108.299 75.5 102.5 75.5C96.701 75.5 92 70.799 92 65C92 59.201 96.701 54.5 102.5 54.5ZM40.5 25.5C46.299 25.5 51 30.201 51 36C51 41.799 46.299 46.5 40.5 46.5C34.701 46.5 30 41.799 30 36C30 30.201 34.701 25.5 40.5 25.5ZM89.5 25.5C95.299 25.5 100 30.201 100 36C100 41.799 95.299 46.5 89.5 46.5C83.701 46.5 79 41.799 79 36C79 30.201 83.701 25.5 89.5 25.5Z",
    fill: "#1F2937"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 66L41 35L65 66.5L90 35L103 66",
    stroke: "#1F2937",
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLight);
export default __webpack_public_path__ + "static/media/logo-light.39c394c37ab641083e22130e01764c11.svg";
export { ForwardRef as ReactComponent };